import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import moment from 'moment'
import { WaterPressurePostDataAPI } from '../../../../../../Redux/WaterSupplyDashBoardSlice/PreventiveWorkWaterSupply/WaterPressureSlice';


export default function WaterPressurePreventiveWorkPopup(props) {

    const { RoleID, handleOnCloseClick, open, Flag, handleIsPost, item, EditIcon, apiFlag, rowData, DashProjectTypeId } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [WaterPressureField, setWaterPressureField] = useState({
        readingDate: Flag === 'Update' ? moment(rowData.readingDate).format("YYYY-MM-DD") : '',
        wardName: Flag === 'Update' ? rowData.wardName : '',
        junctionDetails: Flag === 'Update' ? rowData.junctionDetails : '',
        locationDetails: Flag === 'Update' ? rowData.locationDetails : '',
        pipelineDetails: Flag === 'Update' ? rowData.pipelineDetails : '',
        pressure: Flag === 'Update' ? rowData.pressure : '',

    })

    const handleWaterPressureField = (e) => {
        setWaterPressureField({ ...WaterPressureField, [e.target.name]: e.target.value })
    }

    const handlePost = () => {
        const data = {
            T_WS_WaterPressureID: Flag === 'Update' ? rowData.t_wS_WaterPressureID : '0',
            T_Distri_WaterPressureID: Flag === 'Update' ? rowData.t_Distri_WaterPressureID : '0',
            Flow: WaterPressureField.pressure,
            Pressure: WaterPressureField.pressure,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID
        }
        dispatch(WaterPressurePostDataAPI({ data }))

    }

    return (
        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="water_pop modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Water Pressure</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row">

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Date </b></label>
                                        <input type="date" className="form-control"
                                            name='readingDate'
                                            disabled
                                            aria-describedby="emailHelp"
                                            value={WaterPressureField.readingDate}
                                            onChange={(e) => handleWaterPressureField(e)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Ward Name </b></label>
                                        <input type="text" className="form-control"
                                            name='wardName'
                                            disabled
                                            aria-describedby="emailHelp"
                                            value={WaterPressureField.wardName}
                                            onChange={(e) => handleWaterPressureField(e)}
                                        />
                                    </div>
                                </div>

                                {
                                    (DashProjectTypeId == '6' && RoleID != '16') ?
                                        <>
                                            <div className="col-12 col-md-6 col-lg-6" >
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>Location Name </b></label>
                                                    <input type="text" className="form-control"
                                                        name='junctionDetails'
                                                        disabled
                                                        aria-describedby="emailHelp"
                                                        value={WaterPressureField.locationDetails}
                                                        onChange={(e) => handleWaterPressureField(e)}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className="col-12 col-md-6 col-lg-6" >
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>Junction Name </b></label>
                                                    <input type="text" className="form-control"
                                                        name='junctionDetails'
                                                        disabled
                                                        aria-describedby="emailHelp"
                                                        value={WaterPressureField.junctionDetails}
                                                        onChange={(e) => handleWaterPressureField(e)}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                }

                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Pipe Line (mm) </b></label>
                                        <input type="text" className="form-control"
                                            name='pipelineDetails'
                                            disabled
                                            aria-describedby="emailHelp"
                                            value={WaterPressureField.pipelineDetails}
                                            onChange={(e) => handleWaterPressureField(e)}
                                        />
                                    </div>
                                </div>

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Pressure Value </b></label>
                                        <input type="text" className="form-control"
                                            name='pressure'
                                            aria-describedby="emailHelp"
                                            value={WaterPressureField.pressure}
                                            onChange={(e) => handleWaterPressureField(e)}
                                        />
                                    </div>
                                </div>

                            </div>
                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}